import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useState } from '@wordpress/element';
import { useSelect, useDispatch } from '@wordpress/data';
import { __experimentalBlockNavigationList } from '@wordpress/block-editor';
import { IconButton, SVG, Path, Modal } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
var NavigatorIcon = createElement(SVG, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "20",
  height: "20"
}, createElement(Path, {
  d: "M5 5H3v2h2V5zm3 8h11v-2H8v2zm9-8H6v2h11V5zM7 11H5v2h2v-2zm0 8h2v-2H7v2zm3-2v2h11v-2H10z"
}));
export default function useBlockNavigator(clientId) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isNavigationListOpen = _useState2[0],
      setIsNavigationListOpen = _useState2[1];

  var _useSelect = useSelect(function (select) {
    var _select = select('core/block-editor'),
        getSelectedBlockClientId = _select.getSelectedBlockClientId,
        getBlock = _select.getBlock;

    return {
      block: getBlock(clientId),
      selectedBlockClientId: getSelectedBlockClientId()
    };
  }, [clientId]),
      block = _useSelect.block,
      selectedBlockClientId = _useSelect.selectedBlockClientId;

  var _useDispatch = useDispatch('core/block-editor'),
      selectBlock = _useDispatch.selectBlock;

  var navigatorToolbarButton = createElement(IconButton, {
    className: "components-toolbar__control",
    label: __('Open block navigator'),
    onClick: function onClick() {
      return setIsNavigationListOpen(true);
    },
    icon: NavigatorIcon
  });
  var navigatorModal = isNavigationListOpen && createElement(Modal, {
    title: __('Block Navigator'),
    closeLabel: __('Close'),
    onRequestClose: function onRequestClose() {
      setIsNavigationListOpen(false);
    }
  }, createElement(__experimentalBlockNavigationList, {
    blocks: [block],
    selectedBlockClientId: selectedBlockClientId,
    selectBlock: selectBlock,
    showNestedBlocks: true
  }));
  return {
    navigatorToolbarButton: navigatorToolbarButton,
    navigatorModal: navigatorModal
  };
}
//# sourceMappingURL=use-block-navigator.js.map